import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfilePostsCreated = async ({ uid }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)

		const postsQuerySnap = await userProfileDocRef.collection('postsCreated')
			.orderBy('modifiedTimestamp', 'desc')
			.get()

		const postsCreated = postsQuerySnap.docs.map(d => d.data())
		return postsCreated
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfilePostsCreated



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfilePostsCreated.js